import * as React from "react"
import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

import { WEBBACK_V2_API } from "@constants"
import { brand } from "@signals"


export default function DIPBrandCustomer({ ...props }) {
    return <AutocompleteAsyncSeeker
        multiple
        urlAjax={`${WEBBACK_V2_API}/master-data/brand/customer-options`}
        label="Brands"
        placeholder="Search Brand..."
        value={brand.value}
        onChange={e => brand.value = e.target.value}
        {...props}
    />
}